import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedGame from './components/FeaturedGame';
import About from './components/About';
import Footer from './components/Footer';
import Contact from './components/Newsletter';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <FeaturedGame />
        <About />
      </main>
      <Contact />
      <Footer />
    </div>
  );
}
